import { useEffect, useState } from 'react'
import { getLayoutConfig } from '../config'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import { AFFIL_USER_NAME, useQueryParams } from './useQueryParams'

export const useAffiliate = () => {
  const [affiliateCacheChecked, setAffiliateCacheChecked] = useState(false)
  const { removeQueryParameter, routerQueryParams } = useQueryParams()

  const storedAffiliateUsername = useBookingFormStore((state) => state.affiliate.affilUserName)
  const setAffiliateUsername = useBookingFormStore((state) => state.setAffiliateUsername)
  const clearExpiredAffiliateData = useBookingFormStore((state) => state.clearExpiredAffiliateData)

  useEffect(() => {
    clearExpiredAffiliateData()
    setAffiliateCacheChecked(true)
  }, [clearExpiredAffiliateData])

  useEffect(() => {
    const syncAffiliateQueryParam = async () => {
      if (!(affiliateCacheChecked && storedAffiliateUsername === null)) {
        return
      }

      const config = getLayoutConfig()

      const affiliateUserNameToCheck =
        routerQueryParams?.affilUserName ?? config?.defaultAffiliatePartner

      if (affiliateUserNameToCheck?.trim()) {
        setAffiliateUsername(affiliateUserNameToCheck)
      } else {
        await removeQueryParameter(AFFIL_USER_NAME)
      }
    }

    syncAffiliateQueryParam()
  }, [routerQueryParams?.affilUserName, storedAffiliateUsername, affiliateCacheChecked])
}
